var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('h2',[_vm._v("Template Configuration")]),_c('TemplateConfigForm')],1),_c('QuestionnaireForm',{attrs:{"is-template":"","parent-valid":!_vm.$v.$invalid},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }